import Vue from 'vue'
import VueRouter from 'vue-router'
import _ from 'lodash'
import store from '@/store'
import auth from '@/api/auth'

import companyPaths from './path.company'
import termPaths from './path.term'
import userPaths from './path.user'
import carPaths from './path.car'
import memberPaths from './path.member'
import partsPaths from './path.parts'
import lbsPaths from './path.lbs'


Vue.use(VueRouter)

let allowNullName = [
  'Login',
  'Logout',
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Splash',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Splash'),
      meta: {
        layout: 'NoneLayout'
      }
    },
    {
      path: '/dashboard',
      name: 'DashBoard',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/DashBoard')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login'),
      meta: {
        layout: 'NoneLayout'
      },
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: (to, from, next) => {
        store.dispatch('logout')
        next('/')
      }
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404'),
      meta: {
        layout: 'NoneLayout'
      }
    }
  ]
})

router.addRoutes(companyPaths)
router.addRoutes(termPaths)
router.addRoutes(userPaths)
router.addRoutes(carPaths)
router.addRoutes(memberPaths)
router.addRoutes(partsPaths)
router.addRoutes(lbsPaths)


router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/notFound')
  } else {
    if (_.includes(allowNullName, to.name)) {
      next()
    } else if (store.state.user && to.name === 'Splash') {
      next({
        path: '/dashboard',
        replace: true,
      })
    } else if (!store.state.user && to.name === 'Splash') {
      next({
        path: '/login',
        replace: true,
      })
    } else if (store.state.user === null) {
      auth.refreshToken((flag) => {
        if (flag) {
          if (to.name == 'DashBoard' || to.name == 'Login' || to.name == 'Logout') {
            next()
          } else {
            if (store.state.user == 'admin') next();
            else next('/dashboard')
          }
        } else {
          next({
            path: '/login',
            replace: true,
          })
        }
      })
    } else {
      if (to.name == 'DashBoard' || to.name == 'Login' || to.name == 'Logout') {
        next()
      } else {
        if (store.state.user == 'admin') next()
        else next('/dashboard')
      }

      // 접속시간 제한(10분)
      // if (to.name == 'DashBoard' || to.name == 'Login' || to.name == 'Logout') {
      //   next()
      // } else {
      //   nowDateTime = new Date()

      //   auth.getLogdate((logDate) => {
      //     let newLogDate = new Date(logDate)
      //     let logoutDate = new Date(newLogDate.setMinutes(newLogDate.getMinutes() + 10));

      //     if (logoutDate > nowDateTime) {
      //       next({
      //         path: '/logout',
      //         replace: true,
      //       })
      //     } else {
      //       next()
      //     }
      //   })
      // }
    }
  }
})

export default router
